import { BiogasviewDocument } from './../biogasview-document';
import { Site } from './site';

export class SiteDocument extends BiogasviewDocument{
	site: Site = new Site();
	exported: boolean = false;
	thirdPartyExport: boolean = false;
}